import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { APP_NAME, resolvePageTitle } from "src/constants/pageTitles"

/**
 * Keeps the document title in sync with the current route and returns the
 * human-readable screen name so the shell can announce navigations to screen
 * readers.
 *
 * Single-page apps do not change the window title or notify assistive
 * technology on client-side navigation by default. Setting {@code document.title}
 * satisfies WCAG 2.4.2 (Page Titled); the returned name feeds a polite live
 * region so screen-reader users hear which screen they landed on.
 */
export function usePageTitle(): string {
  const { pathname } = useLocation()
  const title = resolvePageTitle(pathname)

  useEffect(() => {
    document.title = `${title} - ${APP_NAME}`
  }, [title])

  return title
}
